import { assetUrl } from "fusion-core";
import { Helmet } from "fusion-plugin-react-helmet-async";

const ModalActionButtons = ({
  primaryText = "Primary",
  secondaryText = "Secondary",
  onPrimaryClick,
  onSecondaryClick,
  primaryType = "button",
  secondaryType = "button",
  primaryDisabled = false,
  secondaryDisabled = false,
  primaryDisabledStyle = false,
  label,
}) => {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href={assetUrl("../../styles/ModalActionButtons.css")}
        />
      </Helmet>
      <div>
        {label && <p className="modal-action-btns-label">{label}</p>}
        <div className="modal-action-btns">
          <button
            type={secondaryType}
            className={`modal-action-btn modal-action-secondary${
              secondaryDisabled ? " modal-action-disabled" : ""
            }`}
            onClick={onSecondaryClick}
            disabled={secondaryDisabled}
          >
            {secondaryText}
          </button>
          <button
            type={primaryType}
            className={`modal-action-btn modal-action-primary${
              primaryDisabledStyle || primaryDisabled
                ? " modal-action-disabled"
                : ""
            }`}
            onClick={onPrimaryClick}
            disabled={primaryDisabled}
          >
            {primaryText}
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalActionButtons;
